import RouteRepository from "@domain/repositories/RouteRepository";
import UseCase from "@domain/UseCase";
import { Route } from "@domain/models/Route";

type Input = Route["id"];

type Output = Promise<Route>;

export class CancelRouteUseCase implements UseCase<Input, Output> {
  constructor(private readonly routeRepository: RouteRepository) {}

  execute(routeId: Input) {
    return this.routeRepository.cancel(routeId);
  }
}
